exports.en = {
  BACKEND_ERROR: {
    MESSAGE_TITLE: 'Sorry, the application failed.',
    MESSAGE_TEXT: 'Please try <a onclick="window.location.reload(false);">refreshing</a> the page or contact us on <a href="tel:800207207">800 207 207</a>'
  }
}
